import React from 'react';

// local dependencies
import { calendarRange as CalendarRange } from 'modules/calendarRange';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { demo as Demo } from 'ui/views/demo/demo';
 *
 * // render
 * <Demo propName='propValue'/>
 */
export const demo = () => {
    return (
        <div className='ui-demo'>
            <CalendarRange />
        </div>
    );
};

// set display name
demo.displayName = 'demo';

// set default props
demo.defaultProps = {};

// prop types
demo.propTypes = {};
